<template>
  <div>
   <h1>{{heading}}</h1>
   <date-pick v-model="date"></date-pick>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';

export default {
  name: 'Header',
  props: {
    heading: String
  },
  components: {
    DatePick
  },
   data: () => ({
    date: '2019-08-30'
  }),
  watch: {
    date() {
      this.$emit('date-changed', this.date);
    }
  }
}
</script>

<style scoped>


</style>
